// extracted by mini-css-extract-plugin
export default {"label":"HomeProjectLink_label__CjeLX","addToProject":"HomeProjectLink_addToProject__KIeqZ","icon":"HomeProjectLink_icon__muAKo"};